import React, {useRef, useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";

// import IconButton from "@mui/material/IconButton";

import {setLookContextMenu} from "../../../actions/lookFunctions";

import {
  CONTEXT_MENU_VANITY_BUTTONS,
  CONTEXT_MENU_VANITY_ONLY,
  // CONTEXT_MENU_SHOWER_ALL,
  // CONTEXT_MENU_SHOWER_OTHER,
  LOOK_ROOM_TYPES,
} from "../core/constants";
import {getCurrentLayout, getCurrentRoomType} from "../../appLayout";
// import {getLookIdUrl} from "./lookFunctions2";
// import {ROUTES} from "../../../routes";
import {getCommonVisualizerType} from "../../../config";
import {checkIfLookFeaturesReceived} from "../../../api/look-api";
import {loaderDisable, loaderEnable} from "../../ui/loaderView";
import {checkForContextMenuCommon} from "../lookNavigation/lookFunctions";
import goToMaterialPage from "../../common/goToMaterialPage";


const needToRequestFeatureGroupsOnClick = ["vanity_washstand", "vanity_console", "shower_arm", "shower_head"];

const ContextMenuQKBButtons = (props) => {

  const {contextMenu, setLookContextMenu, buttons, setButtons, handleContextMenuClick, activeQuoteIndex,
    renderGreenLayerByZindex} = props;

  const {partId, layerPosition} = contextMenu;
  const anchorRef = useRef(null);
  const [vanitySubMenuOpened, setVanitySubMenuOpened] = useState(false);
  const layout = getCurrentLayout();

  const {allButtons} = checkForContextMenuCommon(partId, layerPosition);
  const isBathroom = getCommonVisualizerType() === "bathroom";
  const isVanity = isBathroom && CONTEXT_MENU_VANITY_BUTTONS.includes(partId);
  // const isShower = isBathroom && (CONTEXT_MENU_SHOWER_ALL.includes(partId) || CONTEXT_MENU_SHOWER_OTHER.includes(partId));

  const contextButtonClick = async (clickedButton) => {
    // console.log("currentPartId", currentPartId);

    const {partId, isWizard, wizardId, hasSubMenu} = clickedButton;

    if (((isVanity && CONTEXT_MENU_VANITY_ONLY.includes(partId)) || hasSubMenu) && !vanitySubMenuOpened) {
      setVanitySubMenuOpened(true);
      if (isVanity) {
        const vanButtons = allButtons.filter(button => CONTEXT_MENU_VANITY_ONLY.includes(button.partId));
        if (vanButtons.length && vanButtons.length > 1) {
          setButtons(vanButtons);
          return false
        }
      } else if (partId === "accessories") {
        const {showButtons} = checkForContextMenuCommon("grab_bar", layerPosition);
        setButtons(showButtons);
        return false
      }
    } else if (vanitySubMenuOpened) {
      // setVanitySubMenuOpened(false);
    }

    setLookContextMenu({
      opened: false,
      layerPosition: "",
      clickedOnItem: partId,
    });

    let openPartId = partId;
    let clickedFeature = null;

    if (isVanity && (getCurrentRoomType(layout) === LOOK_ROOM_TYPES.as) && (partId === "vanity_pedestal_sink" || partId === "vanity_sink")) {
      openPartId = "vanity_sink";
      const sinkParent = layout.getFeatureGroupByPartId(openPartId);
      if (sinkParent) {
        const navItems = layout.designNavigationItems({part: sinkParent}, null, null, sinkParent.activeFeature);
        if (partId === "vanity_pedestal_sink") {
          const pedestalSink = navItems.find(navItem => {
            return navItem.part.metaData["MountType"] && navItem.part.metaData["MountType"].includes("ST")
          });
          if (pedestalSink) {
            clickedFeature = pedestalSink.part;
          }
        } else {
          const isPedestal = sinkParent.activeFeature && sinkParent.activeFeature.metaData["MountType"] && sinkParent.activeFeature.metaData["MountType"].includes("ST");
          if (isPedestal) {
            const regularSink = navItems.find(navItem => {
              return !navItem.part.metaData["MountType"] || !navItem.part.metaData["MountType"].includes("ST")
            });
            if (regularSink) {
              clickedFeature = regularSink.part;
            }
          }
        }
      }
    }

    if (isWizard) {
      goToMaterialPage("visualizer", false, null, "",
        {wizardItemId: wizardId, quoteIndex: activeQuoteIndex});
      return false
    }

    const featureGroup = layout.getFeatureGroupByPartId(openPartId);
    if (featureGroup && !featureGroup.allFeaturesReceived && needToRequestFeatureGroupsOnClick.includes(openPartId)) {
      loaderEnable();
      await checkIfLookFeaturesReceived(featureGroup);
      loaderDisable();
    }

    // console.log("zoomedFeature", clickedFeature);
    handleContextMenuClick(clickedFeature, openPartId);
  };

  const onMouseOver = (button) => {
    if (renderGreenLayerByZindex) {
      const featureGroup = layout.getFeatureGroupByPartId(button.partId);
      if (featureGroup && featureGroup.activeFeature && featureGroup.activeFeature.layer) {
        renderGreenLayerByZindex(featureGroup.activeFeature.layer.zIndex, button.partId);
      }
    }
  }

  let contextMenuStyles = buttons.length === 14 ? {maxWidth:"210px"} : null;

  console.log("buttons", buttons);

  return (
    <div style={contextMenuStyles}>
      <div className="contextmenu-buttons">
        {buttons.map(button => {
          const isVanityParent = isVanity && CONTEXT_MENU_VANITY_ONLY.includes(button.partId);
          return (
            <button key={button.partId}
                    ref={isVanityParent ? anchorRef : null}
                    onMouseOver={() => onMouseOver(button)}
                    onClick={() => contextButtonClick(button)}
                    className={"contextmenu-buttons__button contextmenu-buttons__button--"
                      + (button.partId && (button.partId.includes("wizard") ? "wizard" : button.partId))}>
              {button.partId === "Configure Layout" ? (
                <div className="sprocket-container">
                  <div className="sprocket small spin reverse"/>
                  <div className="sprocket large spin"/>
                </div>
              ) : null}
              <span className="contextmenu-buttons__button-text">
                <FormattedMessage id={button.translateId}/>
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
};

ContextMenuQKBButtons.propTypes = {
  handleContextMenuClick: PropTypes.func,
  setButtons: PropTypes.func,
}

const mapStateToProps = (store) => {
  const {contextMenu} = store.lookState;
  const {isMobile} = store.serverState;
  const {wizardList} = store.wizardState;
  const fabricatorData = store.fabricatorState;
  const {activeQuoteIndex} = store.quotesState;

  return {
    contextMenu,
    isMobile,
    wizardList,
    fabricatorData,
    activeQuoteIndex,
  };
};

const mapDispatchToProps = {
  setLookContextMenu,
};

export default injectIntl(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ContextMenuQKBButtons)
  )
)
